import React from 'react';
import 'moment/locale/nb.js';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { compareDatesAscNullsLast } from 'common/lib/helpers/DateHelpers';
import moment from 'moment';
import { Box } from '@fabric-ds/react';
import { trackRegisterForViewing } from 'common/lib/helpers/trackingService';
import * as S from './styles';
import Entry from './Entry';
import ShowMore from '../showMore';

const getValidEntries = entries => {
    return entries
        .filter(entry => entry.isValidForDisplay)
        .map(({ note, fromDateTime, toDateTime }) => {
            return {
                description: note,
                from: fromDateTime ? moment(fromDateTime) : null,
                to: toDateTime ? moment(toDateTime) : null,
            };
        });
};

const descriptionOnlyEntry = (description, index) => {
    return (
        <li key={index}>
            <p className="text-14">{description}</p>
        </li>
    );
};

const viewingRegistrationButton = url => {
    return (
        <a
            href={url}
            className="button button--secondary min-w-full"
            rel="noopener nofollow noreferrer external"
            target="_blank"
            onClick={() => trackRegisterForViewing()}
        >
            Visningspåmelding
        </a>
    );
};

const entries = (validEntries, calendarUrl, finnkode, address) => {
    return (
        <>
            <h3 className="font-bold mb-16">{validEntries.length > 1 ? 'Visninger' : 'Visning'}</h3>

            <S.EntryList className="pl-0 mb-16">
                <ShowMore>
                    {validEntries
                        .sort((a, b) => compareDatesAscNullsLast(a.from, b.from))
                        .map(({ to, from, description }, index) => {
                            return from == null ? (
                                descriptionOnlyEntry(description, index)
                            ) : (
                                <Entry
                                    finnkode={finnkode}
                                    to={to}
                                    from={from}
                                    description={description}
                                    address={address}
                                    calendarUrl={calendarUrl}
                                    key={index}
                                    index={index}
                                />
                            );
                        })}
                </ShowMore>
            </S.EntryList>
        </>
    );
};

const noOpenHouses = viewingRegistrationUrl => {
    return (
        <>
            <h3 className="font-bold mb-16">Visning</h3>
            {!viewingRegistrationUrl && <p className="mb-16">Ta kontakt for å avtale visning</p>}
        </>
    );
};

const OpenHouse = ({ dates, calendarUrl, finnkode, address, viewingRegistrationUrl }) => {
    const validEntries = dates ? getValidEntries(dates) : null;

    return (
        <Box bordered className="my-16">
            {_.isEmpty(validEntries) ? (
                <>
                    {noOpenHouses(viewingRegistrationUrl)}
                    {viewingRegistrationUrl && viewingRegistrationButton(viewingRegistrationUrl)}
                </>
            ) : (
                <>
                    {entries(validEntries, calendarUrl, finnkode, address)}
                    {viewingRegistrationUrl && viewingRegistrationButton(viewingRegistrationUrl)}
                </>
            )}
        </Box>
    );
};

OpenHouse.propTypes = {
    dates: PropTypes.arrayOf(
        PropTypes.shape({
            fromDateTime: PropTypes.string,
            toDateTime: PropTypes.string,
            note: PropTypes.string,
            isValidForDisplay: PropTypes.bool,
        })
    ),
    calendarUrl: PropTypes.string,
    finnkode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    address: PropTypes.string,
    viewingRegistrationUrl: PropTypes.string,
};

export default OpenHouse;
